module.exports = __webpack_public_path__ + "img/blog4.5de2130f.jpg";